module.exports = __webpack_public_path__ + "static/media/3_3lee.900207c8.png";